export default __webpack_public_path__ + "static/media/Standard45.74a47933.png";